export class Cursus {
    constructor(
        public id?: number,
        public dateDebut?: any,
        public dateFin?: any,
        public interruption?: boolean,
        public motif?: string,
        public titreDiplomePrepare?: string,
        public mentionAutre?: string,
        public anneeSanctionnee?: boolean,
        public intituleDiplome?: string,
        public dateObtentionDiplome?: any,
        public dateCreation?: any,
        public dateModification?: any,
        public candidatureId?: number,
        public etablissement?: string,
        public etablissementAutre?: string,
        public mention?: string,
        public pays?: string,
        public dept?: string,
        public ville?: string,
        public gradeUniversitaireId?: number,
        public typeFormationId?: number,
        public niveauAccesDiplomeId?: number
    ) { }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/cursus.model.ts